<template>
	<BaseModal id="estimate-pignus">
		<template #default="{close}">
            <div class="modal-close" @click="close"></div>
			<div class="modal modal--md">
				<div class="estimate-pignus">
					<div v-if="loadingPignus" class="estimate-pignus__loading">
						<div class="estimate-pignus__loader">
							<div class="loader-static"></div>
						</div>
						<div class="estimate-pignus__text">
							Предварительная оценка залога, <br>
							пожалуйста подождите
						</div>
					</div>
                    <div class="estimate-pignus__content" v-else>
                        <div v-if="pignusDataPrice" class="estimate-pignus__title">
                            Предварительная оценка залога:
                            <span>{{ (+pignusDataPrice).toLocaleString('Ru-ru')}} руб.</span>
                        </div>
                        <template v-else>
                            <div class="estimate-pignus__title">
                                Предварительная оценка по данному товару не доступна.
                            </div>
                            <div class="estimate-pignus__subtitle">
                                Оставьте заявку, оценка залога займет 15 минут
                            </div>
                        </template>
                        <div class="estimate-pignus__params">
                            <div class="estimate-pignus__param">
                                <div class="estimate-pignus__param-title">Желаемая сумма займа</div>
                                <div class="estimate-pignus__param-value">{{ (+getEstimateFormKey('max_loan')).toLocaleString('ru-RU') }} руб.</div>
                            </div>
                            <div class="estimate-pignus__param">
                                <div class="estimate-pignus__param-title">Желаемый срок займа</div>
                                <div class="estimate-pignus__param-value">{{ getEstimateFormKey('max_term') }} дней</div>
                            </div>
                            <div class="estimate-pignus__param">
                                <div class="estimate-pignus__param-title">Предмет залога</div>
                                <div class="estimate-pignus__param-value">{{ loanObjectName }}</div>
                            </div>
                            <div class="estimate-pignus__param">
                                <div class="estimate-pignus__param-title">Выберите предмет залога</div>
                                <div class="estimate-pignus__param-value">
                                    {{ loanObjectItemName?.name }}
                                </div>
                            </div>
                            <div class="estimate-pignus__param">
                                <div class="estimate-pignus__param-title">Фото</div>
                                <div class="estimate-pignus__param-value">
                                    <div class="estimate-pignus__photo">
                                        <div class="preview">
                                            <div
                                                class="preview-img"
                                                v-for="(photo,index) in getEstimateFormKey('photos')"
                                                :key="index"
                                                :style="`background-image: url(${previewUrl(photo)})`"
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="!pignusDataPrice" class="estimate-pignus__description">Текст про то, что оценка предварительная, более точную оценку может дать сотрудник ломбарда</div>
                        <div class="estimate-pignus__actions">
                            <a href="/" class="btn color">На главную</a>
                        </div>

                    </div>

				</div>
			</div>
		</template>
	</BaseModal>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from "vuex";
import BaseModal from "@/components/utils/BaseModal.vue";

export default {
    name: "PopupWelcome",
    components: {BaseModal},
    data() {
        return {
            loadingPignus: true,
            count: 1,
            loading: false,
            pignusDataPrice: ''
        }
    },
    computed: {
        previewUrl() {
			return (photo) => URL.createObjectURL(photo)
		},
        loanObjectName() {
            return this.preScores['accept_types'].find(i => String(i.id) === this.getEstimateFormKey('accept'))?.name
        },

        loanObjectItemName() {
           return this.preScores['accept_types'].find(i => String(i.id) === this.getEstimateFormKey('accept'))?.items.find(i => i.id === +this.getEstimateFormKey('item_id'))
        },

        ...mapGetters({
            preScores: 'estimate/getPreScoreInitials',
            getModalOpened: 'modals/getModalOpened',
            getEstimateFormKey: 'estimate/getEstimateFormKey',
            getPopupWelcome: 'getPopupWelcome',
            isModalOpened: 'modals/isModalOpened',
            pignusId: 'estimate/getPignusId'
        })
    },
    methods: {
        async checkPignusStatus() {
            if(this.count <= 3) {
                this.count++
                const result = await this.requestCheckPignusStatus(this.pignusId)
                if(!result.data.ml_estimate_received) {
                    setTimeout(() => {
                        this.checkPignusStatus()
                    },5000)
                } else {
                    this.pignusDataPrice = result.data.ml_price
                    this.loadingPignus = false
                    this.sendForm();
                }
            } else {
                this.loadingPignus = false
                this.sendForm();
            }
        },


        async sendForm() {
            this.setItemParamsKey({key: 'pre_score_value', value: this.pignusDataPrice})
            await this.sendEstimateForm({mode: 'full'})
        },



        ...mapActions({
            loadPopupWelcome: 'loadPopupWelcome',
            requestCheckPignusStatus: 'estimate/requestCheckPignusStatus',
            sendEstimateForm: 'estimate/sendEstimateForm',
            closeModal: 'modals/closeModal',
        }),
        ...mapMutations({
            setSuccess: 'setPopupSuccessData',
			setItemParamsKey: 'estimate/setItemParamsKey',
        })
    },
    async mounted() {
       
		this.$watch('getModalOpened', () => {
			if (this.isModalOpened('estimate-pignus')) {
                this.count = 1
                this.pignusDataPrice = ''
                this.checkPignusStatus()
			}
		}, {immediate: false})
	},
}
</script>